export default "__VITE_ASSET__1127c02d__"